import React from 'react';
import { X, FileText } from 'lucide-react';

export default function TermsModal({ isOpen, onClose, isDarkMode }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-in fade-in duration-200">
      <div 
        className={`w-full max-w-lg max-h-[80vh] overflow-hidden rounded-2xl shadow-2xl flex flex-col ${
          isDarkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'
        }`}
      >
        {/* Modal Header */}
        <div className={`p-5 border-b flex items-center justify-between ${isDarkMode ? 'border-gray-700' : 'border-gray-100'}`}>
          <div className="flex items-center gap-3">
            <div className={`p-2 rounded-lg ${isDarkMode ? 'bg-gray-700' : 'bg-gray-100'}`}>
              <FileText className="w-5 h-5 text-blue-500" />
            </div>
            <h3 className="font-bold text-lg">Terms of Service</h3>
          </div>
          <button 
            onClick={onClose}
            className={`p-2 rounded-full hover:bg-opacity-80 transition-colors ${
              isDarkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'
            }`}
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Modal Content - Scrollable */}
        <div className="p-6 overflow-y-auto custom-scrollbar">
          <div className={`prose prose-sm ${isDarkMode ? 'prose-invert' : ''}`}>
            <p>Welcome to our platform. By accessing or using our services, you agree to be bound by these terms.</p>
            
            <h4 className="text-base font-semibold mt-4 mb-2">1. Account Security</h4>
            <p className="text-sm opacity-80">You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</p>

            <h4 className="text-base font-semibold mt-4 mb-2">2. User Conduct</h4>
            <p className="text-sm opacity-80">You agree not to use the service for any unlawful purpose or in any way that interrupts, damages, or impairs the service.</p>

            <h4 className="text-base font-semibold mt-4 mb-2">3. Data Privacy</h4>
            <p className="text-sm opacity-80">We collect and process your personal data in accordance with our Privacy Policy. By using this service, you consent to such processing.</p>
            
            <h4 className="text-base font-semibold mt-4 mb-2">4. Modifications</h4>
            <p className="text-sm opacity-80">We reserve the right to modify these terms at any time. Continued use of the platform constitutes acceptance of updated terms.</p>
          </div>
        </div>

        {/* Modal Footer */}
        <div className={`p-5 border-t ${isDarkMode ? 'border-gray-700' : 'border-gray-100'}`}>
          <button
            onClick={onClose}
            className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition-colors"
          >
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
}